import React from "react";
import styled from "styled-components";
import { FaGithub, FaExternalLinkAlt } from "react-icons/fa";

const projects = [
  {
    title: "Gerenciador de Tarefas",
    description:
      "Aplicação usando métodos de inserção com React e TypeScript",
    link: "https://github.com/mateus0205/TaskManager",
    link1: "https://mateus0205.github.io/TaskManager/",
  },
  {
    title: "Projeto RNA - Predição de autismo",
    description:
      "Análise de dados com Redes Neurais Artificiais usando Python",
    link: "https://github.com/mateus0205/Predict-Autism-in-Adults-with-Python",
    // link1 ausente: renderizará o botão desabilitado ("Em breve")
  },
  {
    title: "Gerador de Senhas Seguras",
    description:
      "Gerador automático de senhas criptografadas com Python",
    link: "https://github.com/mateus0205/GeradorDeSenhas",
    link1: "https://geradordesenhas.onrender.com/",
  },
  {
    title: "Portfólio Profissional",
    description:
      "Desenvolvido com React e TypeScript (em andamento)",
    link: "https://github.com/mateus0205/Portifiolio",
    link1: "https://mateus0205.github.io/Portifiolio/",
  },
  {
    title: "Compilador para MIPS",
    description:
      "Conversor de código para máquina real MIPS desenvolvido em C++",
    link: "https://github.com/mateus0205/ConversorCodigoParaMaquinaReal-Mips-",
  },
];

const Projects: React.FC = () => {
  return (
    <Container>
      <ContentWrapper>
        <Title>Projetos Destacados</Title>
        <Grid>
          {projects.map((project, index) => (
            <Card key={index}>
              <CardContent>
                <h3>{project.title}</h3>
                <Description>{project.description}</Description>
                <LinksContainer>
                  <ProjectLink
                    href={project.link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaGithub size={18} />
                    <span>Código Fonte</span>
                  </ProjectLink>

                  {project.link1 ? (
                    <ProjectLink
                      href={project.link1}
                      target="_blank"
                      rel="noopener noreferrer"
                      secondary
                    >
                      <FaExternalLinkAlt size={18} />
                      <span>Demonstração</span>
                    </ProjectLink>
                  ) : (
                    <DisabledButton>
                      <FaExternalLinkAlt size={18} />
                      <span>Em breve</span>
                    </DisabledButton>
                  )}
                </LinksContainer>
              </CardContent>
            </Card>
          ))}
        </Grid>
      </ContentWrapper>
    </Container>
  );
};

export default Projects;

/* Estilos com styled-components */

const Container = styled.div`
  padding: 4rem 2rem;
  min-height: 100vh;
  background: #f8f9fa;
  font-family: "Segoe UI", sans-serif;
`;

const ContentWrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

const Title = styled.h2`
  font-size: 2rem;
  color: #2a5298;
  text-align: center;
  margin-bottom: 3rem;
  position: relative;

  &::after {
    content: "";
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    width: 80px;
    height: 3px;
    background: #ffa726;
  }
`;

const Grid = styled.div`
  display: grid;
  gap: 2rem;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
`;

const Card = styled.div`
  background: white;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  overflow: hidden;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  }
`;

const CardContent = styled.div`
  padding: 2rem;
  height: 100%;
  display: flex;
  flex-direction: column;

  h3 {
    color: #2a5298;
    margin-bottom: 1rem;
    font-size: 1.25rem;
  }
`;

const Description = styled.p`
  color: #666;
  font-size: 0.95rem;
  margin-bottom: 1.5rem;
`;

/* Alterado: removido o margin-top: auto para evitar que os botões sejam empurrados para fora */
const LinksContainer = styled.div`
  display: flex;
  gap: 0.5rem;
  flex-wrap: nowrap; /* Garante que os botões fiquem na mesma linha */
  margin-top: 1rem;
`;


/* Botão de link ativo */
const ProjectLink = styled.a<{ secondary?: boolean }>`
  display: inline-flex;
  flex: 1; /* Permite que os botões ocupem o mesmo espaço */
  text-align: center;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  background: ${({ secondary }) => (secondary ? "#ffa726" : "#2a5298")};
  color: white;
  border-radius: 6px;
  text-decoration: none;
  transition: all 0.3s ease;
  font-size: 0.95rem;
  border: 2px solid transparent;

  &:hover {
    background: ${({ secondary }) => (secondary ? "#ff9800" : "#1e3c72")};
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  svg {
    margin-bottom: 2px;
  }
`;

/* Botão desabilitado para "Em breve" */
const DisabledButton = styled.div`
  text-align: center;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  background: #ccc;
  color: #fff;
  border-radius: 6px;
  font-size: 0.95rem;
  cursor: not-allowed;
  opacity: 0.8;
`;